import React from 'react';
import { Outlet } from 'react-router-dom';

const EmptyLayout: React.FC = () => {
    return (
        <div className="flex h-screen bg-gray-50">
            <div className="flex-1 flex flex-col min-w-0">
                <main className="flex-1 overflow-auto">
                    <div className="p-4 lg:p-6">
                        <Outlet />
                    </div>
                </main>
            </div>
        </div>
    );
};

export default EmptyLayout;
